import styled from 'styled-components';

import {
  Breakpoints,
  Colors,
  MediaDesktop,
  MediaLargeAndAbove,
  MediaMediumAndAbove,
  MediaSmallAndAbove,
  Spacing,
} from '@lichtblick/theme';

export const CasesSliderRoot = styled.section<{ $backgroundColor: Colors }>`
  background: ${({ $backgroundColor }) => $backgroundColor};
  width: 100%;
`;

export const CasesSliderContentWrapper = styled.div`
  padding-bottom: ${Spacing.Xs};
  padding-top: ${Spacing.Xs};
  width: 100%;
  ${MediaDesktop} {
    padding-bottom: ${Spacing.Xl};
    padding-inline: ${Spacing.Xs};
    padding-top: ${Spacing.Xl};
  }
`;

export const SliderContainer = styled.div<{ $slideCount: number }>`
  margin-inline: auto;
  max-width: var(--max-content-width, ${Breakpoints.Large}px);

  ${MediaSmallAndAbove} {
    padding-inline: ${({ $slideCount }) => ($slideCount > 2 ? 0 : Spacing.S)};
  }
  ${MediaMediumAndAbove} {
    padding-inline: ${({ $slideCount }) => ($slideCount > 2 ? Spacing.M : Spacing.L)};
  }
  ${MediaLargeAndAbove} {
    padding-inline: ${({ $slideCount }) => ($slideCount > 2 ? Spacing.M : Spacing.Xl)};
  }
`;
